import { createFileRoute } from "@tanstack/react-router";
import { UseCasePage } from "@/components/blocks/use-cases/UseCasePage";
import { buildUseCaseHead, loadPageLocale } from "@/lib/page-seo";

export const Route = createFileRoute("/{-$locale}/cas-usage/cabinet-qhse")({
	component: () => <UseCasePage useCase="qhse" />,
	loader: loadPageLocale,
	head: ({ loaderData }) =>
		loaderData ? buildUseCaseHead("qhse", loaderData.locale) : {},
});
